// extracted by mini-css-extract-plugin
export default {"tableRow":"tr_tableRow__5Pt-X","isClickable":"tr_isClickable__Ch4dE","isSelected":"tr_isSelected__zuxul"};